import React, { Component } from 'react';
import axios from 'axios';
import DateTime from 'react-datetime';
import './react-datetime.css';
import './DailyView.css';
import 'react-table/react-table.css';
import { CSVLink } from "react-csv";
import { sanitizeCsvData } from './csvSanitizer';
import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';
import ReactDataTable from './ReactDataTable';
import TelemetryDetailModal from './TelemetryDetailModal';
import * as appsettings from './constants';
import { authContext } from '../adalConfig';

// Maps a metric accessor to its display label / stored FailureType.
const METRIC_LABELS = {
    availability: appsettings.Availability,
    reliability: appsettings.Reliability,
    performance: appsettings.Performance
};

export class DailyView extends Component {
    displayName = DailyView.name;
    constructor(props) {
        super(props);
        this.today = new Date();
        this.exceptionDate = new Date();
        this.exceptionDate.setUTCFullYear(1950);
        this.today.setDate(this.today.getDate() - 1);
        this.today.setHours(5);
        this.today.setMinutes(30);
        this.today.setSeconds(0);
        this.state = {
            TempData: [], Metric: [], fromDate: this.today.toISOString(), environment: appsettings.options[0], loading: false, exceptionDate: this.exceptionDate.toISOString(), datatobeshown: appsettings.datatobeshown[0],
            detailModalOpen: false, detailLoading: false, detailError: false, detailData: [],
            detailSeverity: 'orange', detailAppname: '', detailComponent: '', detailService: '', detailDSMService: '',
            detailMetricType: '', detailMetricValue: '', detailTimeRange: ''
        };
        this.onMetricCellClick = this.onMetricCellClick.bind(this);
        this.closeDetailModal = this.closeDetailModal.bind(this);
    }
    // Formats the selected day (UTC) as e.g. "Aug 10, 2026 UTC".
    formatDayRange(startIso) {
        return new Date(startIso).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: '2-digit', timeZone: 'UTC' }) + ' UTC';
    }
    // Collapses duplicate URLs into one row with summed failures, sorted desc.
    aggregateByUrl(records) {
        const map = new Map();
        for (let i = 0; i < records.length; i++) {
            const r = records[i];
            const rawUrl = (r.Url || '').trim();
            if (!rawUrl) { continue; }
            const normalizedUrl = rawUrl.replace(/\/+$/, '').toLowerCase();
            const method = (r.HttpMethod || 'UNKNOWN').trim().toUpperCase();
            const key = `${normalizedUrl}::${method}`;
            const count = Number(r.FailureCount) || 0;
            if (map.has(key)) {
                map.get(key).FailureCount += count;
            } else {
                map.set(key, Object.assign({}, r, {
                    Url: rawUrl,
                    HttpMethod: method === 'UNKNOWN' ? '' : method,
                    FailureCount: count
                }));
            }
        }
        return Array.from(map.values()).sort((a, b) => b.FailureCount - a.FailureCount);
    }
    componentDidMount() {
        this.getData(this.state.environment.value);
    }
    updateFromDate(date) {
        try {
            this.setState({
                fromDate: date._d.toISOString()
            });
        }
        catch (err) {
            this.setState({
                fromDate: this.state.exceptionDate
            });
        }
    }
    onSelectEnvironment(event) {
        this.setState({
            environment: event
        });
        this.getData(event.value);
    }
    onSelectDataToBeShown(event) {
        if (event.value === 'All') {
            this.setState({
                Metric: this.state.TempData
            })
        }
        else {
            var datatobedisplayed = [];
            for (var i = 0; i < this.state.Metric.length; i++) {
                if ((this.state.Metric[i].availability < appsettings.AvailabilityOrangeTarget && this.state.Metric[i].availability > 0)
                    || (this.state.Metric[i].reliability < appsettings.ReliabilityOrangeTarget && this.state.Metric[i].reliability > 0)
                    || (this.state.Metric[i].performance < appsettings.PerformanceOrangeTarget && this.state.Metric[i].performance > 0))
                    datatobedisplayed.push(this.state.Metric[i]);
            }
            this.setState({
                Metric: datatobedisplayed
            })
        }
    }
    getData(environment) {
        this.setState({
            loading: true
        });
        const token = authContext.getCachedToken(authContext.config.clientId);

        var apilink =  "api/CosmosApi/GetDay/?day='" + this.state.fromDate + "'&environment=" + environment;
        axios.get(apilink, 
            {
                headers: {
                    Authorization: `Bearer ${token}` // This correctly adds the token as a Bearer token
                }
            }).then(response => {
            var data = response.data;
            if (typeof data === 'string') {
                try { data = JSON.parse(data); } catch (e) { data = []; }
            }
            if (!Array.isArray(data)) { data = []; }
            this.setState({
                loading: false,
                Metric: data,
                TempData: data
            });
        }).catch(err => {
            console.error('GetDay failed', err);
            this.setState({ loading: false, Metric: [], TempData: [] });
        });
    }
    callgetData() {
        this.getData(this.state.environment.value);
    }
    onMetricCellClick(rowData, accessor, severity) {
        const metricLabel = METRIC_LABELS[accessor] || accessor;
        const appname = rowData.appname || rowData.Component || '';
        // Scope the URL-failure details to the selected day (same 24-hour window
        // shown in this view) so only that day's failures load.
        const start = new Date(this.state.fromDate);
        const end = new Date(start.getTime() + 24 * 60 * 60 * 1000);
        this.setState({
            detailModalOpen: true,
            detailLoading: true,
            detailError: false,
            detailData: [],
            detailSeverity: severity,
            detailAppname: appname,
            detailComponent: rowData.Component || '',
            detailService: rowData.Service || '',
            detailDSMService: rowData.DSMService || '',
            detailMetricType: metricLabel,
            detailMetricValue: rowData[accessor],
            detailTimeRange: this.formatDayRange(start.toISOString())
        });
        this.fetchUrlFailureDetails(appname, this.state.environment.value, metricLabel, start.toISOString(), end.toISOString());
    }
    fetchUrlFailureDetails(appname, environment, metricType, startDate, endDate) {
        const token = authContext.getCachedToken(authContext.config.clientId);
        var apilink = "api/CosmosApi/GetUrlFailureDetails/?appname=" + encodeURIComponent(appname)
            + "&environment=" + encodeURIComponent(environment)
            + "&metricType=" + encodeURIComponent(metricType);
        if (startDate && endDate) {
            apilink += "&startDate=" + encodeURIComponent(startDate) + "&endDate=" + encodeURIComponent(endDate);
        }
        axios.get(apilink, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }).then(response => {
            var data = response.data;
            if (typeof data === 'string') {
                try { data = JSON.parse(data); } catch (e) { data = []; }
            }
            if (!Array.isArray(data)) { data = []; }
            this.setState({
                detailLoading: false,
                detailError: false,
                detailData: this.aggregateByUrl(data)
            });
        }).catch(err => {
            console.error('GetUrlFailureDetails failed', err);
            this.setState({
                detailLoading: false,
                detailError: true,
                detailData: []
            });
        });
    }
    closeDetailModal() {
        this.setState({ detailModalOpen: false });
    }
    openHelp() {
        const url = appsettings.HelpPageRootURL;
        const w = window.open(url, '_blank', 'noopener,noreferrer');
        if (w != null) {
            w.opener = null;
        } else {
            window.location.href = url;
        }
    }
    render() {
        return (
            <div>
                <div id="banner">
                    <h4 id="header">{appsettings.DailyViewHeader}</h4>
                </div>
                <div style={{ height: '8%', width: '100%', display: 'inline-flex', marginTop: '-3%' }}>
                    <div id='EnvTitle'>Environment:</div>
                    <Dropdown className='Environment' options={appsettings.options} onChange={this.onSelectEnvironment.bind(this)} value={this.state.environment} placeholder="Select an option" />
                    <div id='EnvTitle' style={{ marginLeft: '10px' }}>Display:</div>
                    <Dropdown className='datatobedisplayed' options={appsettings.datatobeshown} onChange={this.onSelectDataToBeShown.bind(this)} value={this.state.datatobeshown} placeholder="Select an option" />
                    <div id='starttime'>Start Time:</div>
                    <DateTime className='FromDate' closeOnSelect={true} onBlur={this.updateFromDate.bind(this)} utc={true} defaultValue={this.today} />
                    <button id='GetKPIsButton' onClick={this.callgetData.bind(this)} data-tooltip="Fetch Data">GetKPIs</button>
                    <CSVLink data={sanitizeCsvData(this.state.Metric)} filename={"CSTelemetry.csv"} className="csvExport" headers={appsettings.csvHeaders}>Export to csv</CSVLink>
                    {/* Changed: use anchor to always open in a new tab */}
                    <a
                        id='HelpButton'
                        href={appsettings.HelpPageRootURL}
                        target="_blank"
                        rel="noopener noreferrer"
                        title="ECTelemetry Wiki"
                        aria-label="ECTelemetry Wiki"
                    >
                        ECTelemetry Wiki
                    </a>
                </div>
                <hr />
                <p id='target'>Target : Availability: &gt;={appsettings.AvailabilityGreenTarget}%, Reliability: &gt;={appsettings.ReliabilityGreenTarget}%, Performance: &gt;={appsettings.PerformanceGreenTarget}%</p>
                <ReactDataTable Metric={this.state.Metric} columns={appsettings.columns} loading={this.state.loading} onMetricCellClick={this.onMetricCellClick} />
                <TelemetryDetailModal
                    isOpen={this.state.detailModalOpen}
                    onRequestClose={this.closeDetailModal}
                    severity={this.state.detailSeverity}
                    appname={this.state.detailAppname}
                    component={this.state.detailComponent}
                    service={this.state.detailService}
                    dsmService={this.state.detailDSMService}
                    metricType={this.state.detailMetricType}
                    metricValue={this.state.detailMetricValue}
                    environment={this.state.environment.value}
                    loading={this.state.detailLoading}
                    error={this.state.detailError}
                    details={this.state.detailData}
                    timeRange={this.state.detailTimeRange}
                />

            </div>
        );
    }
}
